<template>
  <div>
    <el-form :inline="true" :model="formData" label-width="80px">
      <el-form-item
          v-for="col in columns"
          :key="col.prop"
          :label="col.label">
        <div>
          <AccountLov v-if="col.prop === 'paymentAccount'" :width="col.width" :value="formData[col.prop]" @callBack="setAccount"/>
          <BillTypeLov v-else-if="col.prop === 'billType'" :width="col.width" :value="formData[col.prop]" @callBack="setBillType"/>
          <CorrespondentsLov v-else-if="col.prop === 'correspondents'" :width="col.width" :value="formData[col.prop]" @callBack="setCorrespondents"/>
          <DepartmentLov v-else-if="col.prop === 'department'" :width="col.width" :value="formData[col.prop]" @callBack="setDepartment"/>
          <SaleTypeLov v-else-if="col.prop === 'saleType'" :width="col.width" :value="formData[col.prop]" @callBack="setSaleType"/>
          <WarehouseLov v-else-if="col.prop === 'warehouse'" :width="col.width" :value="formData[col.prop]" @callBack="setWarehouse"/>
          <el-input v-else style="width: 150px" v-model="formData[col.prop]"/>
        </div>
      </el-form-item>
    </el-form>
    <ProcessLine
        v-if="formData['id'] != null"
        :processId="processId"
        :processIndex="processIndex"
        :isFirstProcess="isFirstProcess"
        :ticketId="formData.id"
        :typeId="typeId"
    />
    <span slot="footer">
      <el-button @click="dialogCloce">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </span>
  </div>
</template>

<script>
import ProcessLine from "@/views/ticket/ProcessLine.vue"
import AccountLov from "@/views/ticket/lov/AccountLov.vue"
import BillTypeLov from "@/views/ticket/lov/BillTypeLov.vue"
import CorrespondentsLov from "@/views/ticket/lov/CorrespondentsLov.vue"
import DepartmentLov from "@/views/ticket/lov/DepartmentLov.vue"
import SaleTypeLov from "@/views/ticket/lov/SaleTypeLov.vue"
import WarehouseLov from "@/views/ticket/lov/WarehouseLov.vue"
import requestTicket from '@/utils/requestTicket'

export default {
  components: {
    ProcessLine,
    AccountLov,
    BillTypeLov,
    CorrespondentsLov,
    DepartmentLov,
    SaleTypeLov,
    WarehouseLov
  },
  name: 'ProcessCreate',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    },
    columnLines: {
      type: Array,
      default: () => []
    },
    typeId: {
      type: [Number, String],
      default: null
    },
    processId: {
      type: [Number, String],
      default: null
    },
    processIndex: {
      type: [Number, String],
      default: null
    },
    isFirstProcess : {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setAccount(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, paymentAccountId: item.id, paymentAccount: item.name});
      }
    },
    setBillType(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, billTypeId: item.id, billType: item.name});
      }
    },
    setCorrespondents(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, correspondentsId: item.id, correspondents: item.name});
      }
    },
    setDepartment(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, departmentId: item.id, department: item.name});
      }
    },
    setSaleType(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, saleTypeId: item.id, saleType: item.name});
      }
    },
    setWarehouse(item){
      if ( item) {
        this.$emit('update:formData', {...this.formData, warehouseId: item.id, warehouse: item.name});
      }
    },
    submitForm() {
      this.$emit('submitForm');
    },
    dialogCloce() {
      this.$emit('dialogCloce');
    }
  }
}
</script>